import { render, staticRenderFns } from "./ModalSaveChange.vue?vue&type=template&id=7cfc8b30&"
import script from "./ModalSaveChange.vue?vue&type=script&lang=js&"
export * from "./ModalSaveChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports